export default function (
  element: HTMLElement,
  itemsArray: HTMLElement[],
  destinationsArray: HTMLElement[],
) {
  const items = itemsArray;
  const categories = new Map();
  const destinations = destinationsArray;

  items.forEach((e: HTMLElement) => {
    const destination = destinations.filter((dest) => {
      return (
        e.getAttribute("data-category") === dest.getAttribute("data-category")
      );
    });
    if (!categories.get(destination)) {
      categories.set(destination[0].getAttribute("data-category"), []);
    }

    categories
      .get(destination[0].getAttribute("data-category"))
      .push(destination[0]);
    destination[0].appendChild(e);
  });

  return categories;
}
